export const nullToUndefinedDeep = <T>(arg: T): DeepNonNull<T> => {
  return nullToUndefined(arg);
};

const nullToUndefinedObject = <T extends Record<string, unknown>>(
  arg: T,
): DeepNonNull<T> => {
  const result: Record<string, unknown> = {};
  Object.keys(arg).forEach((key) => {
    result[key] = nullToUndefined(arg[key as keyof T]);
  });
  return result as DeepNonNull<T>;
};

const nullToUndefinedArray = <T extends any[]>(arg: T): DeepNonNull<T> => {
  const result: any[] = [];
  arg.forEach((value, index) => {
    result[index] = nullToUndefined(value);
  });
  return result as DeepNonNull<T>;
};

const nullToUndefined = (value: any) => {
  if (value === null) {
    return undefined;
  }
  if (Array.isArray(value)) {
    return nullToUndefinedArray(value);
  }
  if (typeof value === "object") {
    return nullToUndefinedObject(value);
  }
  return value;
};

export type NonNull<T> = T extends null ? Exclude<T, null> | undefined : T;

//////////////////////////////////////////////////
//                                              //
// 以下のutility typeは、次のリポジトリを参照しつつ、 //
// 一部カスタムを加えたもの。                       //
// https://github.com/piotrwitek/utility-types //
//                                             //
/////////////////////////////////////////////////

/**
 * DeepNonNull
 * DeepNon*Nullable*ではない点に注意。
 *
 * 既存frontendのコードのtypeが、値が存在しないときnullではなくundefinedを使う一方、
 * GraphQLの返却型においては値が存在しない場合の扱いをnullとしている。
 * このnullとなる箇所をundefinedで置き換えるための型として、このDeepNonNullを定義している。
 */
export type DeepNonNull<T> = T extends (...args: any[]) => any
  ? T
  : T extends any[]
    ? _DeepNonNullArray<T[number]>
    : T extends object
      ? _DeepNonNullObject<T>
      : T;
/** @private */
// tslint:disable-next-line:class-name
export interface _DeepNonNullArray<T> extends Array<DeepNonNull<NonNull<T>>> {}
/** @private */
export type _DeepNonNullObject<T> = {
  [P in keyof T]: DeepNonNull<NonNull<T[P]>>;
};
